"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorEnumTypeToJSON = exports.ErrorEnumTypeFromJSONTyped = exports.ErrorEnumTypeFromJSON = exports.ErrorEnumType = void 0;
/**
 *
 *
 * 1 = GenericError
 *
 * 2 = AnagraficaCedacriStillExistsInDatabase
 * @export
 * @enum {string}
 */
var ErrorEnumType;
(function (ErrorEnumType) {
    ErrorEnumType[ErrorEnumType["NUMBER_1"] = 1] = "NUMBER_1";
    ErrorEnumType[ErrorEnumType["NUMBER_2"] = 2] = "NUMBER_2";
})(ErrorEnumType = exports.ErrorEnumType || (exports.ErrorEnumType = {}));
function ErrorEnumTypeFromJSON(json) {
    return ErrorEnumTypeFromJSONTyped(json, false);
}
exports.ErrorEnumTypeFromJSON = ErrorEnumTypeFromJSON;
function ErrorEnumTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ErrorEnumTypeFromJSONTyped = ErrorEnumTypeFromJSONTyped;
function ErrorEnumTypeToJSON(value) {
    return value;
}
exports.ErrorEnumTypeToJSON = ErrorEnumTypeToJSON;
